import { useState } from "react";
import {
  BsGithub,
  BsEnvelope,
  BsFacebook,
  BsTwitter,
  BsLinkedin,
  BsCloudMoonFill,
  BsSunFill,
  BsInstagram,
  BsYoutube,
} from "react-icons/bs";
const About = () => {
  const [state, setState] = useState([
    { id: 1, title: "name", value: "Shakil Khan" },
    { id: 4, title: "email", value: "shakilkhan621@gmail.com" },
    { id: 5, title: "experiance", value: "7+ years" },
    { id: 8, title: "education", value: "BS Software Engineering" },
  ]);
  const [links, setLinks] = useState([
    {
      id: 1,
      icon: <BsGithub className="text-teal-700 text-base" />,
      href: "https://github.com/shakilkhan12",
    },
    {
      id: 2,
      icon: <BsTwitter className="text-teal-700 text-base" />,
      href: "https://twitter.com/shakilkhan621",
    },
    {
      id: 3,
      icon: <BsFacebook className="text-teal-700 text-base" />,
      href: "https://www.facebook.com/ShakilKhanDesigner",
    },
    {
      id: 4,
      icon: <BsInstagram className="text-teal-700 text-base" />,
      href: "https://www.instagram.com/shakilkhanprogrammer/",
    },
    {
      id: 4,
      icon: <BsLinkedin className="text-teal-700 text-base" />,
      href: "https://www.linkedin.com/in/shakilkhan621/",
    },
    {
      id: 5,
      icon: <BsYoutube className="text-teal-700 text-base" />,
      href: "https://www.youtube.com/channel/UC0uT-8UEmS5LtDj4_d51zkQ",
    },
  ]);
  return (
    <div className="py-[20px] lg:py-[90px] dark:bg-gray-900">
      <div className="container-block">
        <div className="flex flex-wrap -mx-6 items-center">
          <div className="w-full md:w-6/12 p-6">
            <div className="pr-10">
              <h3 className="heading">about me?</h3>
              <h1 className="text-2xl font-semibold mt-6 leading-[35px] dark:text-white">
                I build things for the web.
              </h1>
              <p className="text-[15px] text-gray-600 mt-6 leading-[28px] dark:text-white">
                My name is Shakil Khan, I am a full stack developer based in
                Pakistan with 7+ years of programming experiance. I help convert
                a vision and an idea into meaningful and useful products. Having
                a sharp eye for product{" "}
                <span className="text-lg font-bold">
                  {" "}
                  evolution helps me prioritize tasks,{" "}
                </span>{" "}
                iterate fast and deliver faster.
              </p>
              <div className="mt-6 flex">
                {links.map((link) => (
                  <a
                    className="flex justify-center items-center w-[35px] h-[35px] rounded-full border border-teal-700 ml-3 first:ml-0 hover:rotate-180 transition-all duration-700"
                    href={`${link.href}`}
                    target="_blank"
                  >
                    {link.icon}
                  </a>
                ))}
              </div>
            </div>
          </div>
          <div className="w-full md:w-6/12 p-6">
            {state.map((item) => (
              <li
                key={item.id}
                className="about-list dark:border-b-gray-700 border-b"
              >
                <span className="capitalize text-sm font-medium dark:text-gray-400">
                  {item.title}
                </span>
                <span className="font-medium text-[15px] dark:text-gray-300">
                  {item.value}
                </span>
              </li>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
